import { sendPost } from '../http.js'
const api = {
	'relationList': '/relation/goods/index',
    'relationAdd': '/relation/goods/add',
    'relationRemove': '/relation/goods/remove',
    'authorCourseIndex': '/author/course/index',
    'authorShowIndex': '/author/show/index'
}
export default {
	relationList(params) {
	    return sendPost(api.relationList, params)
	},
    relationAdd(params) {
        return sendPost(api.relationAdd, params)
    },
    authorCourseIndex(params) {
        return sendPost(api.authorCourseIndex, params)
    },
    authorShowIndex(params) {
        return sendPost(api.authorShowIndex, params)
    },
    relationRemove(params) {
        return sendPost(api.relationRemove, params)
    }
}